module.exports = __webpack_public_path__ + "img/success-state.108f01d5.svg";